import React from 'react';
import { TagLayout } from './styles.Tag';

interface TagProps {
    amount?: number;
}

export const Tag: React.FC<TagProps> = ({ children, amount }) => {
    return (
        <TagLayout href={`https://www.br.de/nachrichten/suche/?param=${children}`} target="_blank">
            {children}
        </TagLayout>
    );
};
